module.exports = __webpack_public_path__ + "static/img/ent-detail-34.f6b6db7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-34.jpg
// module id = I4ci
// module chunks = 52